import { render, staticRenderFns } from "./shopIntegral.vue?vue&type=template&id=00bea076&scoped=true"
import script from "./shopIntegral.vue?vue&type=script&lang=js"
export * from "./shopIntegral.vue?vue&type=script&lang=js"
import style0 from "./shopIntegral.vue?vue&type=style&index=0&id=00bea076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bea076",
  null
  
)

export default component.exports